import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {browserHistory} from 'react-router';
import {put, takeLatest, select, take, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';

import {createAllocationSaga} from 'api/allocations';
import {selectDeal} from 'api/deals';
import {selectEnv} from 'reducers/env';

import {
  selectInterest,
  selectAfter,
  persist,
  selectConfirmationToast
} from '../reducer';
import {selectUserSelf} from '../../session/selectors';
const namespace = 'flows/interest/investment';

// Actions
const LOAD_INTEREST_INVESTMENT = defineAction('LOAD_INTEREST_INVESTMENT', namespace);
const SUBMIT_INTEREST_INVESTMENT = defineAction('SUBMIT_INTEREST_INVESTMENT', namespace);

export const loadInterestInvestment = createAction(LOAD_INTEREST_INVESTMENT.ACTION);
export const submitInterestInvestment = createAction(SUBMIT_INTEREST_INVESTMENT.ACTION);

// Interest Investment Saga
export function* interestInvestmentSaga() {
  // Wait for user to click invest
  const {payload: investment} = yield take(SUBMIT_INTEREST_INVESTMENT.ACTION);

  const interest = yield select(selectInterest);
  const userSelf = yield select(selectUserSelf);
  const after = yield select(selectAfter);
  const confirmationToast = yield select(selectConfirmationToast);

  // payload to send to server
  const data = {
    owner: {
      self: userSelf,
    },
    accreditation: {
      accredited: interest.accreditation.accredited,
    },
    investment: {
      // send pennies
      amount: parseInt(investment.amount * 100, 10),
      risk: investment.risk,
    },
    investor: {
      name: interest.investor.name,
      street: interest.investor.street,
      city: interest.investor.city,
      state: interest.investor.state,
      zip: interest.investor.zip,
      ssn: interest.investor.ssn,
      fein: interest.investor.fein,
      type: interest.investor.type,
      taxClassification: interest.investor.taxClassification,
      signatory: interest.investor.signatory,
    },
  };

  // loading indicator
  yield put(persist({allocation: {saving: true}}));

  // API call
  yield call(createAllocationSaga, {payload: {deal: {id: interest.deal.id}, allocation: data}});

  // loading indicator
  yield put(persist({allocation: {saved: true}}));

  const env = yield select(selectEnv);
  if (env.web) {
    // Show toast
    if(confirmationToast === "yes") {
      const {data: deal} = yield select(selectDeal, interest.deal.id);
      const message = `Committed to invest in ${deal.name}`;
      yield call([toast, toast.success], message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }

    // Take them to the next page
    yield call(browserHistory.push, after);
  }
}

export function* sagas() {
  yield takeLatest(LOAD_INTEREST_INVESTMENT.ACTION, interestInvestmentSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/interest/investment/index.js